// Placa clara fixa para icone de tecnicidade (ADR-013, achado 1 do plano).
// Os SVGs do kit tem stroke="#111111" fixo: em tema escuro o icone some sobre
// --color-card. Fix aqui, nao no arquivo: SEMPRE renderiza sobre esta placa,
// igual em claro e escuro. Um so componente — nao duplicar entre a lista do
// cadastro e os chips da ficha do produto (a mesma placa nos dois lugares).
import { cn } from "../lib/utils";

interface TechnicalityIconProps {
  iconUrl: string | null | undefined;
  title: string;
  size?: "sm" | "md" | "lg" | "xl";
  className?: string;
}

const SIZE_CLASS: Record<NonNullable<TechnicalityIconProps["size"]>, string> = {
  sm: "h-[2em] w-[2em] p-[0.35em]",
  md: "h-[2.5em] w-[2.5em] p-[0.4em]",
  lg: "h-[3em] w-[3em] p-[0.5em]",
  // Galeria do cadastro (prototipo v2): placa maior, cantos do cartao.
  xl: "h-[3.5em] w-[3.5em] p-[0.7em] rounded-[0.75em]",
};

export function TechnicalityIcon({
  iconUrl,
  title,
  size = "md",
  className,
}: TechnicalityIconProps): JSX.Element {
  return (
    <span
      className={cn(
        "inline-flex shrink-0 items-center justify-center rounded-md border",
        "bg-icon-plate border-icon-plate-border",
        SIZE_CLASS[size],
        className,
      )}
    >
      {iconUrl ? (
        <img src={iconUrl} alt="" loading="lazy" className="h-full w-full object-contain" />
      ) : (
        <span
          className="text-[0.6em] font-extrabold uppercase text-icon-plate-foreground"
          aria-hidden
        >
          {title.slice(0, 2)}
        </span>
      )}
    </span>
  );
}
